import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import PrintIcon from '@mui/icons-material/Print';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

export default function CodesEmitted(props) {
  const { selectionModel, fActions, children } = props;
  const [productionDate, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [nValidDays, setValidDays] = useState(90);
  const { aAreas } = useOutletContext();
  const fActionsHandler = ev => fActions(ev.target, { once : { productionDate, expirationDate: calcExpire() } });

  function calcExpire() {
    const nNewDateExp = +new Date(productionDate) + nValidDays * 24 * 3600 * 1000;
    return new Date(nNewDateExp).toISOString().slice(0, 10);
  }

  function handleChangeDate(ev) {
    const newDate = ev.target.value;
    if (Date.now() < new Date(newDate)) return alert('Дата производства продукции не должна быть позднее текущей даты.');
    setDate(newDate);
  }

  // useEffect(() => { console.log(aAreas) })

  return <form onSubmit="return false">
    <DialogTitle
      id="draggable-dialog-title"
      sx={{ pr: 8, cursor: 'move', width: 500 }}
    >
      Отчёт о нанесении кодов
    </DialogTitle>
    <DialogContent dividers>
      {children}
      <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
        <Grid item xs={4}>
          <TextField
            type="date"
            variant="outlined"
            label='Дата производства'
            fullWidth
            value={productionDate}
            onChange={handleChangeDate}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            select
            variant="outlined"
            label='Срок годности'
            fullWidth
            value={nValidDays}
            onChange={ev => setValidDays(ev.target.value)}
          >
            <MenuItem key={1} value={90}>90 суток</MenuItem>
            <MenuItem key={2} value={180}>180 суток</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField
            label='Резерв'
            name='rezerv'
            fullWidth
            select
            defaultValue="0"
          >
            <MenuItem key="0" value="0">Нет</MenuItem>
            {aAreas.length && aAreas.map(oArea => oArea.id && <MenuItem key={oArea.id} value={oArea.id} disabled={!oArea.isRezerveble}>{oArea.name}</MenuItem>)}
          </TextField>
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions sx={{ m: 1 }} onClick={fActionsHandler}>
      <Button variant="contained" name='printCodes' title={'Печать'} sx={{ mr: 2 }}>
        <PrintIcon />
      </Button>
      <FormatPaintIcon sx={{ mr: 1 }} />{selectionModel.length} код(а/ов)
      <Button variant="contained" name='utilisationFile' sx={{ mx: 1 }}>Файл</Button>
      <Button variant="contained" name='utilisationSign'>Подписать и отправить</Button>
    </DialogActions>
  </form>
}
